<template>
    <div class="row resultado grey-top-border with-spacing-top no-margin" 
        :insurer="'result-' + additional.company.name" 
        ref="insurerElement">
        <span class="popup_message" ref="popupMessage"></span>

        <!-- Logo Seguradora -->
        <div class='col-xs-3 col-sm-2 small-x-padding'>
            <img class="oferta" src="images/ofertas.png" v-if="showOffer">
            <img 
                class='insurer-badge' 
                :class="{ 'open-insurer': insurerAccess }" 
                :data-insurer-id="additional.company.id" 
                :data-insurer-badge="additional.company.name" 
                :src="(imagesPath || 'images/login-insurers') + '/' + additional.company.name + '.png'" 
                :title="additional.company.name"/>
            <br/>
            <span style="font-size: 10px;">{{ additional.company.name }}</span>
        </div>
        <div class="col-xs-3 col-sm-2 col-md-1 margin-top-15 small-x-padding">
            <div class="produto-adicional" style="margin-top:0px">PRODUTO<br>ADICIONAL</div>
        </div>
        <!-- TEMPO -->
        <div class="col-xs-1 col-md-1 margin-top-15 hidden-xs hidden-sm small-x-padding">
           {{ quotationResult.time }}
        </div>
        <!-- Produto -->
        <div class="col-xs-3 col-md-2 text-left hidden-xs hidden-sm small-x-padding">
            <div class="product">{{ quotationResult.product }}</div>
        </div>
        <!-- Valores -->
        <div class='col-xs-6 col-sm-4 col-md-2 margin-top-15 text-center small-x-padding'>
            <!-- Valor e parcelamento -->
            <a class="amazing-tooltip">
                <div class='in-cash'>{{ numberBrazilianPattern(quotationResult.premium, 2) }}</div>
                <span class='forward hidden-xs hidden-sm'>
                    <div class="payments" v-for="(payments, paymentType) in quotationResult.installments" :key="paymentType">
                        <h5>{{ paymentTypesPreDefinition[paymentType] || paymentType }}</h5>
                        <div v-for="(value, key) in payments" :key="key">
                            {{ key }} - R$ {{ value }}
                        </div>
                    </div>
                </span>
            </a>
        </div>
        <!--Acesso Detalhes da Cotação e BOTÕES DE AÇÕES -->
        <div v-show="false" class="col-xs-10 col-xs-offset-1 col-sm-3 small-x-padding">
            <div>
                <button
                    :data-preco-id="quotationResult.priceId"
                    type="button"
                    class="btn btn-primary no-margin open-residence-quotation hidden-xs hidden-sm"
                    v-if="insurerAccess"
                    disabled>
                    <span>
                        <i class="fa fa-sign-in"></i>
                        Abrir na seguradora
                    </span>
                </button>
                <button
                    :data-preco-id="quotationResult.priceId"
                    type="button"
                    onclick="location.href=javascript:void(0)"
                    class="btn btn-primary btn-block btn-xs no-margin open-residence-quotation visible-xs-block visible-sm-block"
                    v-if="insurerAccess">
                    <span>
                        <i class="fa fa-sign-in"></i>
                        Abrir
                    </span>
                </button>
            </div>
            <div>
                <button
                    type="button"
                    class="btn btn-link no-padding-sides hidden-xs hidden-sm no-margin"
                    data-toggle="modal"
                    @click="showQuotationModalInsurerResult = true">
                    <i class="fa fa-info-circle"></i> Detalhes da cotação
                </button>
                <button
                    type="button"
                    class="btn btn-link no-padding-sides no-margin visible-xs-block visible-sm-block"
                    data-toggle="modal"
                    @click="showQuotationModalInsurerResult">
                    <i class="fa fa-info-circle"></i> Detalhes
                </button>
            </div>
            <div>
                <a
                    v-if="isPDFValid()"
                    :id="'pdf-' + quotationResult.priceId"
                    :ref="'pdf-' + quotationResult.priceId"
                    class="btn btn-link no-padding no-margin hidden-xs hidden-sm"
                    :href="quotationResult.pdf"
                    target="_blank">
                    <span>
                        <i class="fa fa-file-pdf-o"></i> PDF da cotação
                    </span>
                </a>
            </div>
        </div> 

        <partial-modal-result-insurer-details
            v-if="showQuotationModalInsurerResult"
            @close="showQuotationModalInsurerResult = false"
            :imagesPath="imagesPath"
            :insurer="additional.company"
            :quotationResult="quotationResult">
        </partial-modal-result-insurer-details>

    </div>
</template>

<script>
    import PartialModalResultInsurerDetails from './PartialModalResultInsurerDetails.vue'
    import jQuery from 'jquery'

    export default {
        props: ['additional', 'insurer', 'result', 'insurerAccess','pdfs'],
        components: {
            PartialModalResultInsurerDetails,
        },
        data(){
            return {
                isFirefox: typeof InstallTrigger !== 'undefined',
                showQuotationModalInsurerResult: false,
                showOffer: false,
                quotationResult: {
                    time: null,
                    value: null,
                    franchise: null,
                    coverages: null,
                    otherCoverages: null,
                    otherCoveragesHover: '',
                    franchises: null,
                    franchisesHover: null,
                    code: null,
                    priceId: null,
                    residence: null,
                    residenceHover: '',
                    product: null,
                    message: null,
                    messageHover: '',
                    adjustments: null,
                    adjustmentsHover: '',
                    paymentForms: {},
                    pdf: "",
                    erropdf: false
                },
            }
        },
        watch: {
            pdfs(listaPdfs) {
                if (listaPdfs) this.insertPDF(listaPdfs);
            }
        }, 
        computed: {
            paymentTypesPreDefinition(){
                return this.$store.state.Result.paymentTypesPreDefinition
            },
            imagesPath(){
                return this.$root.$options.config.imagesPath
            }
        },
        created() {
            this.tabId = this.generateGuid();
        },
        mounted() {            
            // this.showOffer = this.additional.oferta === true
            this.quotationResult.time                = this.additional.time
            this.quotationResult.premium             = this.additional.premium
            this.quotationResult.installments        = this.additional.installments
            this.quotationResult.franchise           = this.additional.franchise
            this.quotationResult.coverages           = this.additional.company_coverages
            this.quotationResult.otherCoverages      = "" //this.additional.outras_coberturas
            this.quotationResult.otherCoveragesHover = "" //this.additional.outras_coberturas_completo_popup
            this.quotationResult.franchises          = this.additional.company_franchises
            this.quotationResult.franchisesHover     = "" //this.additional.franquias_popup
            this.quotationResult.code                = this.additional.company_reference
            this.quotationResult.priceId             = "" //this.additional.preco_id
            this.quotationResult.residence           = "" //this.additional.residencia
            this.quotationResult.residenceHover      = "" //this.quotationResult.residence
            this.quotationResult.product             = this.additional.product
            // this.quotationResult.message             = this.additional.messages.replace(/\n/, '<br>')
            this.quotationResult.message             = this.additional.messages
            this.quotationResult.messageHover        = this.additional.messages
            // this.quotationResult.adjustments         = this.additional.adjustments.replace(/\n/, '<br>')
            this.quotationResult.adjustments         = this.additional.adjustments
            this.quotationResult.adjustmentsHover    = this.additional.adjustments

            this.$nextTick(() => {
                jQuery(this.$refs.insurerElement).find('.dynamic').scroll(() => {
                    jQuery('.dynamic').scrollLeft(jQuery(this.$refs.insurerElement).find('.dynamic').scrollLeft())
                })

                this.$store.dispatch('onSaveInsurerQuotation', this.additional)
            })
        },
        methods: {
            generateGuid() {
                return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                    (
                    c ^
                    (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
                    ).toString(16)
                );
            },
            insertPDF(list) {
                let pdf = list.filter(
                value => value.id === this.quotationResult.priceId);
                if (pdf[0]) {
                    this.quotationResult.pdf = pdf[0].company_data ? pdf[0].company_data.pdf: null || pdf[0].pdf;
                    if (this.quotationResult.pdf && this.quotationResult.pdf.length < 1) {
                    this.quotationResult.erropdf = true;
                    }
                }
            },
            showPopupMessage(event){
                let target       = jQuery(event.target)
                let messageHover = target.data('msg-hover')

                if(messageHover.length === 0)
                    return

                let popupMessage = jQuery(this.$refs.popupMessage)
                let posX         = target.offset().left - jQuery('#resultados').offset().left
                let posY         = 0

                popupMessage.html(messageHover)

                let popUpWidth  = popupMessage.width() + (this.isFirefox ? 35 : 0)
                let popUpHeight = popupMessage.height() + (this.isFirefox ? 35 : 0)

                if (target.parent('div.error').length) {
                    popupMessage.css('top', posY - popUpHeight)
                    popupMessage.css('left', posX + ((target.width() / 2) - popUpWidth))
                } else {
                    popupMessage.css('top', posY - popUpHeight)
                    popupMessage.css('left', posX - popUpWidth)
                }

                popupMessage.show()
            },
            hidePopupMessage(event){
                jQuery(this.$refs.popupMessage).hide()
            },
            isPDFValid() {
                if (this.quotationResult.pdf && this.quotationResult.pdf.length > 1)
                    return true
                return false
            },
            numberBrazilianPattern (num, fraction = 2, simple = true) {               
                let newNum = Number(num)
                if (simple === true && (isNaN(newNum) || newNum == null || newNum === 'NaN' || newNum === NaN)) {
                    num = num.replace(/\./g, '').replace(',', '.')
                    newNum = Number(num)
                }
                return newNum.toLocaleString('pt-BR', { minimumFractionDigits: fraction, maximumFractionDigits: fraction })
			}
        }
    }
</script>

<style src="residential/sass/result-insurer.scss" lang="sass" scoped></style>


// WEBPACK FOOTER //
// PartialInsurerAdditionalProduct.vue?385c862f